/**
 * Display form of a sales-order number: the branch's own running series with
 * the branch code-prefix stripped off (e.g. "MB0001" → "0001"). The prefix is
 * kept on `orders.code` for cross-branch uniqueness, but it's noise to a
 * cashier who only ever sees their own branch's orders — they want a clean
 * "Sales Order #0001".
 *
 * Falls back to the full code when the prefix is unknown or doesn't match
 * (e.g. the random fallback codes minted for branch-less / prefix-less orders).
 */
export function salesOrderSeries(code: string, prefix?: string | null): string {
  if (prefix && code.startsWith(prefix)) return code.slice(prefix.length);
  return code;
}
